import React from 'react';
import { db } from '../utils/firebase';
import { doc, setDoc } from 'firebase/firestore';
import { validateProfile } from '../utils/activities';
import { calculateBMR, calculateBMI, calculateFFMI, calculateTargetGoals } from '../utils/bodyMetrics';
import logger from '../utils/logger';
import BMRPopup from './BMRPopup';
import BMIPopup from './BMIPopup';

// Stateless feature component. Owns no state of its own — the parent (User.js)
// fetches profile data and passes it down, receives updates via setProfile.
// The BMR/BMI popups are self-contained components with their own show/hide
// state and portal rendering (see step 4).
function ProfileCard({ userId, profile, setProfile, loadingProfile, onError }) {
  const handleProfileSave = async () => {
    const validationError = validateProfile(profile);
    if (validationError) {
      onError(validationError);
      return;
    }
    const profileData = {
      userId: userId,
      targetWeight: parseFloat(profile.targetWeight) || 0,
      targetDate: profile.targetDate || ''
    };
    try {
      await setDoc(doc(db, 'users', userId), profileData, { merge: true });
      setProfile(prev => ({ ...prev, ...profileData, currentWeight: prev.currentWeight }));
    } catch (error) {
      logger.error(error, { page: 'User', action: 'saveProfile' });
      onError('Failed to save profile. Please try again.');
    }
  };

  return (
    <div className="profile-info">
      <h3>Your Profile</h3>
      {loadingProfile ? (
        <p className="loading">Loading...</p>
      ) : (
        <>
          <strong>
            <label>
              Current Weight (lbs): <span>{profile.currentWeight || 'N/A'}</span>
            </label>
          </strong>
          <label>
            Target Weight (lbs):
            <input
              type="number"
              value={profile.targetWeight}
              onChange={(e) => setProfile({ ...profile, targetWeight: e.target.value })}
            />
          </label>
          <label>
            Target Date:
            <input
              type="date"
              value={profile.targetDate}
              onChange={(e) => setProfile({ ...profile, targetDate: e.target.value })}
            />
          </label>
          <button className="btn-primary" onClick={handleProfileSave}>Save Profile</button>
          {calculateTargetGoals(profile) && <p>{calculateTargetGoals(profile)}</p>}
          <p>
            BMR: {calculateBMR(profile).toFixed(0)} calories/day{' '}
            <BMRPopup />
          </p>
          <p>
            BMI: {calculateBMI(profile).toFixed(1)}{' '}
            <BMIPopup profile={profile} />
          </p>
          {calculateFFMI(profile) !== null && (
            <p>
              FFMI: {calculateFFMI(profile).toFixed(1)}
            </p>
          )}
        </>
      )}
    </div>
  );
}

export default ProfileCard;
